import React from 'react'
import './ReferralProgressBar.scss'

const ReferralProgressBar = ({
  currentVotes,
  totalVotes = 0,
  highlight,
  barColor,
  completeColor,
  highlightColor,
  showVoteCount = true,
}) => {
  const currentPercentage =
    totalVotes > 0 ? Math.round((currentVotes / totalVotes) * 100) : 0
  const barCurrentColor = currentPercentage >= 100 ? completeColor : barColor
  const barHighlight = highlight ? highlightColor : barCurrentColor
  return (
    <div className="referral-progress">
      <div className="referral-progress-bar">
        <div className="bar-total">
          <div
            className="bar-current"
            style={{
              width: currentPercentage + '%',
              backgroundColor: barHighlight,
            }}
          ></div>
        </div>
        <div className="bar-percentage">{currentPercentage}% </div>
      </div>
      {showVoteCount && (
        <div className="referral-progress-count">
          {currentVotes}/{Math.round(totalVotes)}
        </div>
      )}
    </div>
  )
}

export default ReferralProgressBar
